import { FC } from "react";

import { withCompositeFormikField } from "@lib/withFormikField";

import OptionButtonGroupRow from "./OptionButtonRow";
import OptionButtonGroupRowList from "./OptionButtonRowList";
import { TOptionButtonGroupProps } from "./types";

const OptionButtonGroup: FC<TOptionButtonGroupProps> = ({
  lines,
  onChange,
  value,
  options,
  isMultiple = false,
  name,
  testId,
  isFill,
  setFieldValue,
  ...props
}) => {
  if (isMultiple && value && !Array.isArray(value)) {
    throw new Error("When 'allowToSelectMultiple' prop is set to 'true', 'value' prop must be an array or undefined.");
  }

  if (!isMultiple && value && Array.isArray(value)) {
    throw new Error("'value' prop must be a string, number or undefined.");
  }

  return lines ? (
    <OptionButtonGroupRowList
      lines={lines}
      options={options}
      value={value}
      name={name}
      testId={testId}
      onChange={(elem) => {
        setFieldValue?.(elem);
        onChange?.(elem);
      }}
      isMultiple={isMultiple}
    />
  ) : (
    <OptionButtonGroupRow
      {...props}
      options={options}
      value={value}
      name={name}
      testId={testId}
      onChange={(elem) => {
        setFieldValue?.(elem);
        onChange?.(elem);
      }}
      isMultiple={isMultiple}
      isFill={isFill}
    />
  );
};
export default withCompositeFormikField({ hasSetFieldValue: true, hasOnChangeCallback: false })(OptionButtonGroup);
